<ul class="layout-menu">
    <li pin-it-track-web-app-menuitem *ngFor="let item of applicationServiceExt.sidebarMenuItems; let i = index;" [menuItem]="item" [menuItemIndex]="i" [isRoot]="true"></li>
</ul>
